import { IconSearchAlt, mapper } from '@maia/icons';
import {
  CardHeader,
  FeaturedIcon,
  ActionButton,
  CardFooter,
  Badge,
  cardStyles,
} from '@maia/ui';
import { twMerge } from 'tailwind-merge';
import { NoteDto } from '@maia/shared';
import { formatDate } from '@maia/utils';

type Props = {
  note: NoteDto;
  onClick: () => void;
};

export function RecentNoteCard(props: Props) {
  const { note, onClick } = props;

  return (
    <div className={twMerge(cardStyles({ variant: 'outlined' }), 'p-12')}>
      <CardHeader
        title={note.title}
        subtitle={note.content}
        icon={
          <FeaturedIcon variant="modern" size="sm" icon={mapper(note.icon)} />
        }
        actions={[
          <ActionButton icon={IconSearchAlt} size="small" onPress={onClick} />,
        ]}
        alignIcon
      />
      <CardFooter
        className="mt-8"
        timestamp={{ showIcon: true, date: formatDate(note.createdAt) }}
      >
        <Badge
          label={note.createdBy.firstName ?? note.createdBy.initials}
          avatar={{
            initials: note.createdBy.initials,
          }}
        />
      </CardFooter>
    </div>
  );
}
